import { transportRequestService, locationService, vehicleService, shipmentService, plannerService } from '@/_services'
import { Auth } from '@/_services/amplify.service.js'
import { generalHelpers } from '@/_helpers'
import * as type from './types'
import i18n from '@/i18n'
import router from '@/router'

const actions = {
  createTransport ({ commit }, { ref, origin, destination, labels, pickup, delivery, incoterms, priority, status, order, comment, restrictions, units }) {
    transportRequestService.createTransport({
      ref, origin, destination, labels, pickup, delivery, incoterms, priority, status, order, comment, restrictions, units
    }).then((response) => {
      console.log(response)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.order_created'), color: 'success' })
    }).catch((error) => {
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      console.error(error)
    })
  },
  setTransportDetails ({ commit }, { transportDetails }) {
    commit(type.SET_SELECTED_TRANSPORT, { transport: transportDetails })
  },
  // setTransportStatus ({ commit }, { transportID, value, oldVal }) {
  //   commit(type.SET_SELECTED_TRANSPORT_STATUS, { value })
  //   transportRequestService.setTransportStatus({ transportID, value }).then(() => {
  //     commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.transport.status_updated'), color: 'success' })
  //   }).catch((error) => {
  //     console.error(error)
  //     commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
  //     commit(type.SET_SELECTED_TRANSPORT_STATUS, { status: oldVal })
  //   })
  // },
  setTransportPriority ({ commit }, { transportID, value, oldVal }) {
    commit(type.SET_SELECTED_TRANSPORT_PRIORITY, { value: value.value })
    transportRequestService.setTransportPriority({ transportID, value }).then(() => {
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.transport.priority_updated'), color: 'success' })
    }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(type.SET_SELECTED_TRANSPORT_PRIORITY, { value: oldVal })
    })
  },
  setTransportStatus ({ commit }, { transportID, value, oldVal }) {
    commit(type.SET_SELECTED_TRANSPORT_STATUS, { value: value.value })
    transportRequestService.setTransportStatus({ transportID, value }).then(() => {
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.transport.status_updated'), color: 'success' })
    }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(type.SET_SELECTED_TRANSPORT_STATUS, { value: oldVal })
    })
  },
  setTransportIncoterms ({ commit }, { transportID, value, oldVal }) {
    commit(type.SET_SELECTED_TRANSPORT_INCOTERMS, { value: value.id })
    transportRequestService.setTransportIncoterms({ transportID, value }).then(() => {
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.transport.incoterms_updated'), color: 'success' })
    }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(type.SET_SELECTED_TRANSPORT_INCOTERMS, { value: oldVal })
    })
  },
  setTransportComment ({ commit }, { transportID, value, oldVal }) {
    commit(type.SET_SELECTED_TRANSPORT_COMMENT, { value: value })
    transportRequestService.setTransportComment({ transportID, value }).then(() => {
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.transport.comment_updated'), color: 'success' })
    }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(type.SET_SELECTED_TRANSPORT_COMMENT, { value: oldVal })
    })
  },
  setTransportRestrictions ({ commit }, { transportID, value, oldVal }) {
    commit(type.SET_SELECTED_TRANSPORT_RESTRICTIONS, { value: value })
    transportRequestService.setTransportRestrictions({ transportID, value }).then(() => {
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.transport.restrictions_updated'), color: 'success' })
    }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(type.SET_SELECTED_TRANSPORT_RESTRICTIONS, { value: oldVal })
    })
  },

  updateUnitsInTransport ({ commit }, { transportID, added, removed, units, oldVal }) {
    transportRequestService.updateUnitsInTransport({ transportID, added, removed }).then((response) => {
      if (added.length > 0) {
        let index = 0
        units.forEach(unit => {
          if (!unit.id) {
            unit.id = response[index]
            index++
          }
        })
      }
      commit(type.UPDATE_TRANSPORT_UNITS, { units })
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.transport.units_updated'), color: 'success' })
    }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(type.UPDATE_TRANSPORT_UNITS, { value: oldVal })
    })
  },

  setTransportPickupDelivery ({ commit }, { transportID, value, oldVal }) {
    commit(type.SET_SELECTED_TRANSPORT_PICKUP_DELIVERY, { value: value })
    transportRequestService.setTransportPickupDelivery({ transportID, transport: value }).then(() => {
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.transport.pickup_delivery_updated'), color: 'success' })
    }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(type.SET_SELECTED_TRANSPORT_PICKUP_DELIVERY, { value: oldVal })
    }).finally(() => {
    })
  },
  setSelectedOrderOriginLocation ({ commit }, { locationID }) {
    locationService.getLocation({ locationID }).then((response) => {
      commit(type.SET_SELECTED_ORDER_ORIGIN_LOCATION, { location: response })
    })
  },
  setSelectedOrderDestinationLocation ({ commit }, { locationID }) {
    locationService.getLocation({ locationID }).then((response) => {
      commit(type.SET_SELECTED_ORDER_DESTINATION_LOCATION, { location: response })
    })
  },
  setTransportEnums ({ commit }) {
    vehicleService.getVehicleEquipmentEnum().then((response) => {
      commit(type.SET_TRANSPORT_ENUMS, { vehicleEquipment: response.map(({ name }) => (name)) })
    })
    transportRequestService.getCargoRestrictionsEnum().then((response) => {
      commit(type.SET_TRANSPORT_ENUMS, { cargoRestrictions: response.map(({ name }) => (name)) })
    })
    locationService.getLocationEquipmentEnum().then((response) => {
      commit(type.SET_TRANSPORT_ENUMS, { locationEquipment: response.map(({ name }) => (name)) })
    })
  },
  quoteTransport({ commit }, { transportID }) {
    commit(type.IS_CREATING_SHIPMENT, { state: 'loading' })
    let shipment = null
    shipmentService.createShipment({
      labels: []
    })
    .then((response) => {
      shipment = { ...response }
      return generalHelpers.delay(5000)
    })
    .then(() => {
      return transportRequestService.getTransportRequestDrop({ id: transportID })
    })
    .then((transport) => {
      const dropID = transport.drops[0].id
      return plannerService.plannerMoveDropToShipment({
        newShipmentID: shipment.id,
        dropID
      })
    })
    .then(() => {
      return generalHelpers.delay(5000)
    })
    .then(() => {
      return  Auth.currentSession()
    })
    .then((session) => {
      commit(type.IS_CREATING_SHIPMENT, { state: null })
      if (session.getIdToken().payload.org === 'ea22334c-25eb-4eb7-bc70-1f30a04d7544') {
        router.push({ name: 'ShipmentsQuote', params: { shipmentID: shipment.id } })
      } else {
        router.push({
          path: `/shipments-by-day/${shipment.id}/quote`
        })
      }
    })
    .catch((error) => {
      console.error(error)
      commit(type.IS_CREATING_SHIPMENT, { state: 'error' })
    })
  },
  createQuoteTransport ({ commit, dispatch }, { ref, origin, destination, labels, pickup, delivery, incoterms, priority, status, order, comment, restrictions, units }) {
    let transport = null
    commit(type.IS_CREATING_SHIPMENT, { state: 'loading' })
    transportRequestService.createTransport({
      ref, origin, destination, labels, pickup, delivery, incoterms, priority, status, order, comment, restrictions, units
    })
    .then((response) => {
      transport = response.data.createTransport
      return generalHelpers.delay(5000)
    })
    .then(() => {
      dispatch('quoteTransport', { transportID: transport.id })
    })
    .catch((error) => {
      commit(type.IS_CREATING_SHIPMENT, { state: null })
      console.error(error)
    })
  }
}

export default actions
